// slices/loaderSlice.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  language: 'en'
};

const languageSlice = createSlice({
  name: 'language',
  initialState,
  reducers: {
    setLanguage: (state, action) => {
      let language = action.payload;
      state.language = language;
    },
  },
});

export const { setLanguage } = languageSlice.actions;
export default languageSlice.reducer;